<template>
    <div :style="refresh ? 'margin-top: 1px' : ''">
        <table class="w-full d-none d-md-table" >
            <thead class="h-11 bg-lightGray">
            <tr class="font-bold">
                <td class="px-2">#</td>
                <td class="px-2">{{ $t('product.name') }}</td>
                <td class="px-2">{{ $t('productPriceModify.price') }}</td>
                <td class="px-2">{{ $t('unitOfMeasure.short') }}</td>
                <td class="px-2">{{ $t('productPriceModify.marja') }}</td>
                <td class="px-2">{{ $t('productPriceModify.newPrice') }}</td>
                <td class="px-2">{{ $t('inventory.sumDifference') }}</td>
                <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(piw, index) of piwList" :key="piw.id" class="h-11">
                <td class="px-2">{{ piw.id }}</td>
                <td class="px-2 font-bold text-main">{{ piw.product.name }}</td>
                <td class="px-2">{{ showCurrencyById(piw.product.sellingPriceCurrency.id, piw.oldPrice) }}</td>
                <td class="px-2">{{ showUnitOfMeasure(piw.product.unitOfMeasure) }}</td>
                <td class="px-2">
                    <b-form-input
                        @input="setMarja(piw)"
                        v-model="piw.marja"
                        type="number"
                        class="w-16 border-gray-300 focus:ring-0"
                    />
                </td>
                <td class="px-2">
                    <b-form-input
                        @input="setPrice(piw)"
                        v-model="piw.newPrice"
                        type="number"
                        class="w-32 border-gray-300 focus:ring-0"
                    />
                </td>
                <td class="px-2">
                    <div class="rounded py-1 text-center" :style="`background-color: ${howBgColor(parseFloat(piw.oldPrice) < parseFloat(piw.newPrice))}`">
                        <span>{{ parseFloat(Math.abs(piw.product.sellingPrice - piw.newPrice).toFixed(2)) }}</span>
                        <font-awesome-icon
                            v-if="parseFloat(piw.oldPrice) < parseFloat(piw.newPrice)"
                            class="icon-link-green ml-2 mb-1"
                            :icon="['fa', 'arrow-up']"
                        />
                        <font-awesome-icon
                            v-if="parseFloat(piw.oldPrice) > parseFloat(piw.newPrice)"
                            class="icon-link-red ml-2 mb-1"
                            :icon="['fa', 'arrow-down']"
                        />
                    </div>
                </td>
                <td class="px-2">
                    <img src="/images/Union.png" alt="" class="h-6 cursor-pointer" @click="deleteOneRow(index)">
                </td>
            </tr>
            </tbody>
        </table>
        <table class="w-full d-md-none">
            <tbody  v-for="(piw, index) of piwList" :key="piw.id" style="border-bottom: 5px solid #444444">
            <tr class="h-11">
                <td class="px-2 font-weight-bold">#</td>
                <td class="px-2">{{ piw.id }}</td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('product.name') }}</td>
                <td class="px-2 text-main" style="width: 50%">{{ piw.product.name }}</td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('productPriceModify.price') }}</td>
                <td class="px-2">{{ showCurrencyById(piw.product.sellingPriceCurrency.id, piw.product.sellingPrice) }}</td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('unitOfMeasure.short') }}</td>
                <td class="px-2">{{ showUnitOfMeasure(piw.product.unitOfMeasure) }}</td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('productPriceModify.marja') }}</td>
                <td class="px-2">
                    <b-form-input
                        @input="setMarja(piw)"
                        v-model="piw.marja"
                        type="number"
                        class="w-16 border-gray-300 focus:ring-0"
                    />
                </td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('productPriceModify.newPrice') }}</td>
                <td class="px-2">
                    <b-form-input
                        @input="setPrice(piw)"
                        v-model="piw.newPrice"
                        type="number"
                        class="w-32 border-gray-300 focus:ring-0"
                    />
                </td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('inventory.sumDifference') }}</td>
                <td class="px-2">
                    <div class="rounded py-1 text-center" :style="`background-color: ${howBgColor(parseFloat(piw.oldPrice) < parseFloat(piw.newPrice))}`">
                        <span>{{ parseFloat(Math.abs(piw.product.sellingPrice - piw.newPrice).toFixed(2)) }}</span>
                        <font-awesome-icon
                            v-if="parseFloat(piw.oldPrice) < parseFloat(piw.newPrice)"
                            class="icon-link-green ml-2 mb-1"
                            :icon="['fa', 'arrow-up']"
                        />
                        <font-awesome-icon
                            v-if="parseFloat(piw.oldPrice) > parseFloat(piw.newPrice)"
                            class="icon-link-red ml-2 mb-1"
                            :icon="['fa', 'arrow-down']"
                        />
                    </div>
                </td>
            </tr>
            <tr class="h-11">
                <td></td>
                <td class="px-2">
                    <img src="/images/Union.png" alt="" class="h-6 cursor-pointer" @click="deleteOneRow(index)">
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import currencyFormatMixin from "@/mixin/currencyFormatMixin";

export default {
    name: "ProductModifyMakeListTable",
    mixins: [currencyFormatMixin],
    props: {
        piwList: {
            type: Array,
            required: true
        },
        isNeedRefresh: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        refresh() {
            return this.isNeedRefresh
        }
    },
    methods: {
        deleteOneRow(index) {
            this.$emit('deleteOneRow', index)
        },
        setMarja(piw) {
            piw.newPrice = parseFloat(piw.oldPrice) + (piw.marja * piw.oldPrice / 100)

            this.$emit('refresh')
        },
        setPrice(piw) {
            if (piw.newPrice !== '') {
                piw.marja = Math.round(100 - piw.oldPrice * 100 / piw.newPrice)

                this.$emit('refresh')
            }
        },
        howBgColor(isPositive) {
            return isPositive ? '#D4F8E5' : '#FFCDB8'
        },
    }
}
</script>

<style scoped>
.icon-link-red {
    color: red;
    font-size: 13px;
    //position: relative;
    //bottom: 5px;
}

.icon-link-green {
    color: #04f304;
    font-size: 13px;
    //position: relative;
    //bottom: 5px;
}

.checkmark-n {
    color: red;
    font-size: 22px;
    cursor: pointer;
}

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}
</style>
